module.exports = __webpack_public_path__ + "img/static__image.b732db37.png";